export const HOME_SET_ONWARD_PB_DATE = 'HOME_SET_ONWARD_PB_DATE';
export const HOME_SET_RETURN_PB_DATE = 'HOME_SET_RETURN_PB_DATE';
export const HOME_PB_SET_SOURCE_CITY = 'HOME_PB_SET_SOURCE_CITY';
export const HOME_PB_SET_DESTINATION_CITY = 'HOME_PB_SET_DESTINATION_CITY';
export const HOME_GET_META_DATA_BEGIN = 'HOME_GET_META_DATA_BEGIN';
export const HOME_GET_META_DATA_SUCCESS = 'HOME_GET_META_DATA_SUCCESS';
export const HOME_GET_META_DATA_FAILURE = 'HOME_GET_META_DATA_FAILURE';
export const HOME_GET_META_DATA_DISMISS_ERROR = 'HOME_GET_META_DATA_DISMISS_ERROR';
export const HOME_GET_UNIQUE_CITIES_BEGIN = 'HOME_GET_UNIQUE_CITIES_BEGIN';
export const HOME_GET_UNIQUE_CITIES_SUCCESS = 'HOME_GET_UNIQUE_CITIES_SUCCESS';
export const HOME_GET_UNIQUE_CITIES_FAILURE = 'HOME_GET_UNIQUE_CITIES_FAILURE';
export const HOME_GET_UNIQUE_CITIES_DISMISS_ERROR = 'HOME_GET_UNIQUE_CITIES_DISMISS_ERROR';
export const HOME_SET_HOME_STATE = 'HOME_SET_HOME_STATE';
export const HOME_SET_TRANSFER_DATA = 'HOME_SET_TRANSFER_DATA';
export const HOME_PB_SET_TYPE = 'HOME_PB_SET_TYPE';
export const HOME_SET_KUPOS_GO_DATA = 'HOME_SET_KUPOS_GO_DATA';
export const HOME_KUPOS_GO_POST_TRIP_DETAILS_BEGIN = 'HOME_KUPOS_GO_POST_TRIP_DETAILS_BEGIN';
export const HOME_KUPOS_GO_POST_TRIP_DETAILS_SUCCESS = 'HOME_KUPOS_GO_POST_TRIP_DETAILS_SUCCESS';
export const HOME_KUPOS_GO_POST_TRIP_DETAILS_FAILURE = 'HOME_KUPOS_GO_POST_TRIP_DETAILS_FAILURE';
export const HOME_KUPOS_GO_POST_TRIP_DETAILS_DISMISS_ERROR =
  'HOME_KUPOS_GO_POST_TRIP_DETAILS_DISMISS_ERROR';
export const HOME_RESET_NEW_PASSWORD_BEGIN = 'HOME_RESET_NEW_PASSWORD_BEGIN';
export const HOME_RESET_NEW_PASSWORD_SUCCESS = 'HOME_RESET_NEW_PASSWORD_SUCCESS';
export const HOME_RESET_NEW_PASSWORD_FAILURE = 'HOME_RESET_NEW_PASSWORD_FAILURE';
export const HOME_RESET_NEW_PASSWORD_DISMISS_ERROR = 'HOME_RESET_NEW_PASSWORD_DISMISS_ERROR';
export const HOME_ACCOUNT_CONFIRMATION_BEGIN = 'HOME_ACCOUNT_CONFIRMATION_BEGIN';
export const HOME_ACCOUNT_CONFIRMATION_SUCCESS = 'HOME_ACCOUNT_CONFIRMATION_SUCCESS';
export const HOME_ACCOUNT_CONFIRMATION_FAILURE = 'HOME_ACCOUNT_CONFIRMATION_FAILURE';
export const HOME_ACCOUNT_CONFIRMATION_DISMISS_ERROR = 'HOME_ACCOUNT_CONFIRMATION_DISMISS_ERROR';
export const HOME_SET_SEARCH_APP = 'HOME_SET_SEARCH_APP';
export const HOME_API_CALL_BEGIN = 'HOME_API_CALL_BEGIN';
export const HOME_API_CALL_SUCCESS = 'HOME_API_CALL_SUCCESS';
export const HOME_API_CALL_FAILURE = 'HOME_API_CALL_FAILURE';
export const HOME_API_CALL_DISMISS_ERROR = 'HOME_API_CALL_DISMISS_ERROR';
export const HOME_SET_TERMINALS = 'HOME_SET_TERMINALS';
export const HOME_GET_SITE_MAP_BEGIN = 'HOME_GET_SITE_MAP_BEGIN';
export const HOME_GET_SITE_MAP_SUCCESS = 'HOME_GET_SITE_MAP_SUCCESS';
export const HOME_GET_SITE_MAP_FAILURE = 'HOME_GET_SITE_MAP_FAILURE';
export const HOME_GET_SITE_MAP_DISMISS_ERROR = 'HOME_GET_SITE_MAP_DISMISS_ERROR';
export const HOME_SET_SITE_MAP_DATA = 'HOME_SET_SITE_MAP_DATA';
export const HOME_SET_AT_MASTERS_DATA = 'HOME_SET_AT_MASTERS_DATA';
export const HOME_SET_META_DATA = 'HOME_SET_META_DATA';
export const HOME_SET_STAGES_DATA = 'HOME_SET_STAGES_DATA';
export const IS_MOT = 'IS_MOT';
export const CUPONERA_SEATS = 'CUPONERA_SEATS';



// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js